/**
 * `/admin/automation/quotas` — the coding-account quota table (A7Y-3812).
 *
 * Split off the ADDIS status page because it answers a different question.
 * ADDIS status is retrospective: did the automation run, did it pass. Quota is
 * predictive: is there capacity for the next cycle to run at all. Sharing a
 * page meant the one figure that says whether anything will happen next sat
 * below three tables about what already happened.
 *
 * The per-account detail page at `/admin/automation/quota/:account` is
 * unchanged and still reads from this page's cached queries.
 */
import { PageHeader } from '@/components/PageHeader';
import { QuotaStatusSection } from './QuotaStatusSection';

export default function QuotaPage() {
  return (
    <div className="space-y-4">
      <PageHeader
        title="AI Quotas"
        subtitle="Session and weekly usage for every coding account, and which one the last waterfall implemented on. Open a row for capacity, reset times and refresh errors."
      >
        <div className="text-xs text-zinc-500">Polls 30s</div>
      </PageHeader>

      <QuotaStatusSection />
    </div>
  );
}
